import { create } from "zustand";

const useCashCarryArbStore = create((set) => ({
    arbData: [],
    lastUpdated: null,
    
    setInitialData: (data) => set({
        arbData: data,
        lastUpdated: new Date().toISOString()
    }),
    
    updateArb: (update) => set((state) => {
        const existingIndex = state.arbData.findIndex(item => item.stock_symbol === update.stock_symbol);
        let newData = [...state.arbData];
        if (existingIndex >= 0) {
            newData[existingIndex] = { ...newData[existingIndex], ...update };
        } else {
            newData.push(update);
        }
        return {
            arbData: newData,
            lastUpdated: new Date().toISOString()
        };
    })
}));

export default useCashCarryArbStore;
